import { Field, FieldSubtype, FieldType } from "@/core/types/types";
import { camundaApi } from "@/core/api/camundaApi";

export enum ActionType {
  NurturingUnsubscribe = "unsubscribe",
  NurturingUnsubscribeError = "unsubscribeError",
}

export interface ActionContent {
  field: Field;
  displayStepTitle: string;
  action: Function;
  errorField: Field;
  displayErrorStepTitle: string;
}

export interface ActionProperties {
  action: string;
  processId: string;
  utm_campaign: string;
  syncSignature?: boolean;
}

export const actions: { [key in ActionType as string]: ActionContent } = {
  [ActionType.NurturingUnsubscribe]: {
    field: {
      id: ActionType.NurturingUnsubscribe,
      key: ActionType.NurturingUnsubscribe,
      label: "action.unsubscribe.success",
      type: FieldType.Text,
      properties: {
        subtype: FieldSubtype.Unsubscribe,
      },
    },
    displayStepTitle: "reminder-unsubscribe",
    action: camundaApi.unsubscribe,
    errorField: {
      id: ActionType.NurturingUnsubscribeError,
      key: ActionType.NurturingUnsubscribeError,
      label: "action.unsubscribe.success",
      type: FieldType.Text,
      properties: {
        subtype: FieldSubtype.UnsubscribeError,
      },
    },
    displayErrorStepTitle: "reminder-unsubscribe-error",
  },
};
